{
  "title": "Pay & taxes",
  "lead": "Estimate your local taxes, save the estimate, and pay at the Treasurer's Office.",
  "noOnlinePay": "Online payment isn't available yet. Pay at the Treasurer's counter and keep your official receipt.",
  "tab_cedula": "Community tax",
  "tab_rpt": "Real property tax",
  "tab_business": "Business tax",
  "tab_mine": "My estimates",
  "estimateTitle": "Your estimate",
  "estimateNote": "This is an estimate. The Treasurer's Office computes the official amount when you pay.",
  "enterValues": "Enter your amounts to see the estimate.",
  "total": "Total",
  "invalidAmount": "Enter an amount in pesos, like 180000",
  "amountHint": "Last year's amount. Leave blank if none.",
  "cedulaTitle": "Community tax certificate (cedula)",
  "cedulaWho": "Who is paying",
  "cedulaIndividual": "Individual",
  "cedulaJuridical": "Corporation or partnership",
  "cedulaLead": "Enter last year's income. Leave blank what doesn't apply to you.",
  "cedulaJuridicalLead": "Enter last year's figures for the business.",
  "salaries": "Salaries or wages (₱)",
  "businessIncome": "Gross receipts from business or profession (₱)",
  "propertyIncome": "Income from real property (₱)",
  "propertyAssessedValue": "Assessed value of real property owned (₱)",
  "grossReceipts": "Gross receipts or earnings from business (₱)",
  "cedulaLaw": "Local Government Code Sec. 157: ₱5.00 basic tax, plus ₱1.00 for every ₱1,000 of income, up to ₱5,000 more.",
  "cedulaJuridicalLaw": "Local Government Code Sec. 158: ₱500 basic tax, plus ₱2.00 for every ₱5,000 of property value and of gross receipts, up to ₱10,000 more.",
  "cedulaDue": "Pay by the last day of February. Later payment adds interest of 24% a year (LGC Sec. 161).",
  "cedulaBring": "Bring a valid ID and proof of income, such as your income tax return or certificate of compensation.",
  "rptTitle": "Real property tax (amilyar)",
  "rptLead": "Use the values printed on your tax declaration.",
  "marketValue": "Market value (₱)",
  "propertyClass": "Kind of property",
  "chooseClass": "Choose the kind of property",
  "classOption": "{label} ({percent}%)",
  "otherClass": "Other — I'll enter the level",
  "assessmentLevel": "Assessment level (%)",
  "assessmentLevelHint": "Printed on your tax declaration, for example 20.",
  "levelInvalid": "Enter a percent from 1 to 100",
  "tdNumber": "Tax declaration number",
  "payInAdvance": "I'll pay the whole year in advance ({discount}% discount)",
  "assessedValue": "Assessed value",
  "perQuarter": "Per quarter (without discount)",
  "ratesCeiling": "Using the legal maximum rates: {basic}% basic tax and {sef}% Special Education Fund (LGC Secs. 233 and 235). The LGU's ordinance may set lower rates.",
  "ratesLgu": "Rates published by the Treasurer's Office: {basic}% basic tax and {sef}% Special Education Fund.",
  "rptDue": "Pay yearly, or in four installments due by March 31, June 30, September 30 and December 31 (LGC Sec. 250).",
  "rptDiscountLaw": "The LGU may grant up to 20% off for paying in advance or on time (LGC Sec. 251).",
  "lguNotes": "Note from the Treasurer's Office",
  "businessTitle": "Business tax and permit fees",
  "businessLead": "Business tax is computed by the Business Permits and Licensing Office (BPLO) and the Treasurer from last year's gross sales, using the rates in the municipal revenue code, together with regulatory fees.",
  "businessWindow": "Renewal window",
  "businessWindowBody": "Generally January 1 to 20 each year (LGC Sec. 165), unless the LGU extends it.",
  "businessPrepare": "What to prepare",
  "businessPrepareBody": "Last year's permit, declared gross sales, barangay clearance, and the other clearances the BPLO asks for.",
  "businessPay": "Assessment and payment",
  "businessPayBody": "The BPLO and the Treasurer compute your taxes and fees; you pay at the Treasurer's Office.",
  "businessServices": "See BPLO services",
  "save": "Save this estimate",
  "saving": "Saving…",
  "saved": "Saved as {ref}. Show it at the Treasurer's counter.",
  "signInToSave": "Sign in to save this estimate",
  "signInToSee": "Sign in to see the estimates you saved.",
  "mineTitle": "My estimates",
  "mineEmpty": "No saved estimates yet",
  "mineEmptyBody": "Use the community tax or real property tax estimator and save it to pay at the counter.",
  "showAtCounter": "Show this reference or QR code at the Treasurer's counter.",
  "reference": "Reference",
  "qrAlt": "QR code for {ref}",
  "showBreakdown": "See how it was computed",
  "status_unpaid": "To pay at the counter",
  "status_paid": "Paid",
  "status_cancelled": "Cancelled",
  "paidWith": "Paid {date} · OR {or}",
  "savedOn": "Saved {date}",
  "taxYear": "Tax year {year}",
  "cancel": "Cancel this estimate",
  "cancelTitle": "Cancel this estimate?",
  "cancelBody": "You can always make a new one.",
  "cancelYes": "Yes, cancel",
  "keep": "Keep it",
  "cancelled": "Estimate cancelled.",
  "cancelledOn": "Cancelled {date}",
  "type_cedula_individual": "Community tax (individual)",
  "type_cedula_juridical": "Community tax (corporation)",
  "type_rpt": "Real property tax",
  "line_basicCedula": "Basic community tax",
  "line_additionalCedula": "Additional community tax",
  "line_basicRpt": "Basic real property tax",
  "line_sef": "Special Education Fund",
  "line_discount": "Discount for paying in advance",
  "deskTitle": "Revenue desk",
  "deskLead": "Estimates residents saved to pay here. Find one by reference, name or mobile number, then record the official receipt.",
  "tab_desk": "Estimates",
  "tab_rates": "Tax rates",
  "search": "Reference, name or mobile number",
  "filterStatus": "Status",
  "filterAll": "All",
  "filterYear": "Tax year",
  "allYears": "All years",
  "scan": "Scan QR",
  "scanTitle": "Scan the resident's QR code",
  "scanHint": "Or type the reference in the search box.",
  "cameraView": "Camera view",
  "startCamera": "Start camera",
  "stopCamera": "Stop camera",
  "cameraDenied": "Camera access is blocked. Allow it in the browser settings, or type the reference.",
  "cameraError": "The camera couldn't start. Type the reference instead.",
  "notAnEstimate": "That QR code isn't an estimate reference.",
  "totalsUnpaid": "To collect",
  "totalsPaid": "Collected",
  "countOne": "1 estimate",
  "countOf": "{count} estimates",
  "exportCsv": "Download CSV",
  "deskEmpty": "No estimates found",
  "deskEmptyBody": "Residents save estimates from Pay & taxes in the app.",
  "deskEmptySearch": "Check the reference or try the resident's mobile number.",
  "deletedAccount": "Account deleted",
  "readOnly": "You can look up estimates. Recording payments needs the editor role.",
  "recordPayment": "Record payment",
  "deskCancel": "Cancel",
  "payTitle": "Payment for {ref}",
  "payLead": "After {name} pays {amount}, enter the number on the official receipt.",
  "orNumber": "Official receipt (OR) number",
  "orHint": "As printed on the receipt. Each OR can be recorded only once.",
  "payConfirm": "Record payment",
  "paidToast": "Payment recorded. The resident has been notified.",
  "orLine": "OR {or} · {date}",
  "recordedBy": "by {name}",
  "deskCancelTitle": "Cancel {ref}?",
  "deskCancelBody": "Do this only if the resident asks, or if it was saved by mistake.",
  "ratesTitle": "Tax rates for the estimators",
  "ratesLead": "Residents' real property tax estimates use these rates. Leave a rate blank to use the legal maximum, which is shown as such.",
  "ratesReadOnly": "Only editors can change the rates.",
  "lastUpdated": "Last updated {date}",
  "basicRate": "Basic real property tax (%)",
  "basicRateHint": "Legal maximum: 1% for provinces, 2% for cities and Metro Manila municipalities.",
  "sefRate": "Special Education Fund (%)",
  "sefRateHint": "Legal maximum: 1%.",
  "advanceDiscount": "Discount for paying the year in advance (%)",
  "promptDiscount": "Discount for paying on time (%)",
  "discountHint": "Up to 20% (LGC Sec. 251). Leave blank if none.",
  "rateInvalid": "Enter a number from 0 to {max}",
  "levelsTitle": "Assessment levels by kind of property",
  "levelsHint": "From the provincial or city ordinance, for example Residential 20%. Residents can pick these in the estimator.",
  "levelLabel": "Kind of property",
  "levelPercent": "Level (%)",
  "levelLabelRequired": "Name the kind of property",
  "addLevel": "Add a kind of property",
  "removeLevel": "Remove {label}",
  "notes": "Note for residents",
  "notesHint": "Shown with the real property tax estimator, e.g. the ordinance number or office hours.",
  "saveRates": "Save rates",
  "ratesSaved": "Rates saved."
}
